import React from "react";
import {
  Table,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  Button,
  Badge,
  Text,
} from "@tremor/react";
import { toFriendlyTime } from "../../../services/utils";

export default function OAuthClientTable({ clients, isLoading, onEdit, onDelete }) {
  if (isLoading) {
    return <Text>Loading OAuth clients...</Text>;
  }

  if (!clients || clients.length === 0) {
    return <Text>No OAuth clients found. Add a client to get started.</Text>;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Client ID</TableHeaderCell>
          <TableHeaderCell>Description</TableHeaderCell>
          <TableHeaderCell>Status</TableHeaderCell>
          <TableHeaderCell>Created</TableHeaderCell>
          <TableHeaderCell>Actions</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {clients.map((client) => (
          <TableRow key={client.clientId}>
            <TableCell>{client.name}</TableCell>
            <TableCell>{client.clientId}</TableCell>
            <TableCell>
              <Text truncate={true}>{client.description || 'No description'}</Text>
            </TableCell>
            <TableCell>
              {client.isActive ? (
                <Badge color="green">Active</Badge>
              ) : (
                <Badge color="red">Inactive</Badge>
              )}
            </TableCell>
            <TableCell>{toFriendlyTime(client.createdAt)}</TableCell>
            <TableCell>
              <div className="flex space-x-2">
                <Button
                  size="xs"
                  variant="secondary"
                  onClick={() => onEdit(client)}
                >
                  Edit
                </Button>
                <Button
                  size="xs"
                  variant="light"
                  color="red"
                  onClick={() => onDelete(client)}
                >
                  Delete
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}